import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
};

export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    firstName: 'First Name',
    lastName: 'Last Name',
    birthDate: 'Date of Birth',
    emailAddress: 'Email Address',
    postalCode: 'Work Postal Code',
    verifyMyFirstResponderStatus: 'VERIFY MY FIRST RESPONDER STATUS',
    infoShared1: ' ',
    infoShared2: 'Information entered here will be used for verification purposes and shared with Bass Pro Shops. ',
    error: 'ERROR',
    requiredFields: 'All fields required.',
    poweredBy: 'Verification services powered by SheerID.',
    limitExceededError: 'ALREADY REDEEMED',
    errorId: {
        verificationLimitExceeded: 'We\'re glad you\'re enthusiastic, but it looks like you\'ve already redeemed this offer.',
    },
    step: {
        personalInfo: {
            title: 'UNLOCK THIS FIRST RESPONDER-ONLY OFFER',
            howDoesVerifyingWorkDetails: 'This offer is available to all US first responders and emergency personnel - including law\nenforcement, EMTs, paramedics, and firefighters.<br><br>Bass Pro Shops uses SheerID, a trusted partner, to verify\nthat you are an active first responder. SheerID only collects information that assists in verifying your eligibility.\nAdditional information or documentation may be requested.',
        },
        success: {
            title: 'SUCCESS! YOU\'VE BEEN VERIFIED',
            subtitle: 'A confirmation email, which includes the discount codes, has been emailed to you.',
            verificationOnly: 'Verification services powered by SheerID. <a class="sid-faq sid-link" href="https://verify.sheerid.com/first-responder-faq/" target="_blank"><span>SheerID FAQs</span></a>',
        },
        docUpload: {
            title: 'WE NEED MORE INFORMATION',
            uploadInstructions: 'Upload an official document that shows:',
            howDoesVerifyingWorkDetails: 'Document review is handled by SheerID, a trusted partner who specializes in verifying first\nresponders.<br><br>Documents are used only for verifying your first responder status is current and will be permanently\ndeleted after review is finalized. They will not be shared with Bass Pro Shops.',
            submitButtonLabel: 'SUBMIT',
            cancelButtonLabel: 'CANCEL',
        },
        pending: {
            titleReview: 'PROCESSING',
            subtitle2: ' ',
        }
    },
};
